import { useEffect, useRef } from "preact/hooks";

const MS_IN_HOUR = (60 * 60 * 1000);
const MS_SLEW_DELAY = 15000; // Just in case our time isn't exactly correct, and account for icecast delay.

function timeUntilNextHour() {
    const now = new Date().getTime();
    const msIntoHour = now % MS_IN_HOUR;
    return MS_IN_HOUR - msIntoHour;
}

export function useEffectEveryHourOnTheHour(func: () => any) {
    const savedCallback = useRef<() => any>();
    useEffect(() => {
        savedCallback.current = func;
    }, [func]);
    useEffect(() => {
        let id: number;
        function tick() {
            savedCallback.current();
            id = setTimeout(tick, timeUntilNextHour() + MS_SLEW_DELAY);
        }
        id = setTimeout(tick, timeUntilNextHour() + MS_SLEW_DELAY);
        return () => clearTimeout(id);
    }, []);
}
